import {
  CONSUMER_DATA_LICENSES,
  ORG_ACTIVE_STATUS,
  ORG_INACTIVE_STATUS,
  ORG_TYPES,
  ORGS_TABLE_FILTERS,
} from '../constants';

export const USER_SUBSCRIPTION = {
  endDate: 1679410252449,
  id: 'AzZiz7TYgiMXq2Kcf',
  itemPriceId: 'Pro-USD-Monthly',
  startDate: 1679409647649,
};

export const ACTIVE_ORG = {
  attr: {
    address: '',
    city: '',
    country: '',
    status: ORG_ACTIVE_STATUS,
    supportAddress: '',
    zip: '',
  },
  code: 'FORTUNE',
  consumerDataLicenses: {
    [CONSUMER_DATA_LICENSES.cusip]: {
      enabled: false,
    },
    [CONSUMER_DATA_LICENSES.other]: {
      enabled: false,
    },
    [CONSUMER_DATA_LICENSES.sedol]: {
      enabled: false,
    },
  },
  createdAt: '2022-11-16T17:58:32.259+00:00',
  description: 'Fortune Test Organization',
  filterCatalogBySuppliers: [],
  id: 'Or8oYDo-',
  legacyId: 'IQF8oYDo-_fIP2zwEZF0u-00sw',
  markedComplete: false,
  modifiedAt: '2022-11-16T17:58:32.259+00:00',
  name: 'Fortune',
  status: ORG_ACTIVE_STATUS,
  type: ORG_TYPES.supplier,
  website: 'www.fortune.com',
};

export const DEACTIVATED_ORG = {
  attr: {
    address: '1234 Banana St',
    city: '',
    country: '',
    deactivatedAt: '2023-03-13T03:53:51.341+00:00',
    state: 'TN',
    zip: '123456',
  },
  consumerDataLicenses: {
    [CONSUMER_DATA_LICENSES.cusip]: {
      enabled: false,
    },
    [CONSUMER_DATA_LICENSES.other]: {
      enabled: false,
    },
    [CONSUMER_DATA_LICENSES.sedol]: {
      enabled: false,
    },
  },
  createdAt: '2018-10-16T22:13:23.000+00:00',
  description: 'Crux Test Organization',
  filterCatalogBySuppliers: [],
  id: 'Orj0pgJw',
  legacyId: 'IQFj0pgJw7Lzcov6ggjDDgynlg',
  markedComplete: false,
  modifiedAt: '2019-12-05T03:53:51.341+00:00',
  name: 'Crux',
  status: ORG_INACTIVE_STATUS,
  website: 'https://www.cruxdata.com',
};

export const ORGS = [ACTIVE_ORG, DEACTIVATED_ORG];

export const ORG_ACTIVITY_MONTHS = [
  {
    data: {
      activeDataProducts: 5,
      draftDataProducts: 3,
      rowsDelivered: 25,
    },
    date: '2022-01-21T18',
  },
  {
    data: {
      activeDataProducts: 20,
      draftDataProducts: 5,
      rowsDelivered: 50,
    },
    date: '2022-02-21T18',
  },
  {
    data: {
      activeDataProducts: 32,
      draftDataProducts: 9,
      rowsDelivered: 100,
    },
    date: '2022-03-21T18',
  },
];

export const ACTIVE_ORGS_FILTERS = {
  ...ORGS_TABLE_FILTERS,
  status: {
    ...ORGS_TABLE_FILTERS.status,
    value: [ORG_ACTIVE_STATUS],
  },
  type: {
    ...ORGS_TABLE_FILTERS.type,
    value: ORG_TYPES.consumer,
  },
};

export const DEACTIVATED_ORGS_FILTERS = {
  ...ORGS_TABLE_FILTERS,
  status: {
    ...ORGS_TABLE_FILTERS.status,
    value: [ORG_INACTIVE_STATUS],
  },
  type: {
    ...ORGS_TABLE_FILTERS.type,
    value: ORG_TYPES.supplier,
  },
};

export const ALL_ORGS_LOCAL_FILTER = {
  ...ORGS_TABLE_FILTERS,
  status: {
    active: false,
    deactivated: false,
  },
  type: {
    consumer: false,
    supplier: false,
  },
};

export const ACTIVE_ORGS_LOCAL_FILTER = {
  ...ORGS_TABLE_FILTERS,
  status: {
    active: true,
    deactivated: false,
  },
  type: {
    consumer: true,
    supplier: false,
  },
};

export const ORG_DATA_PRODUCT_ENTITLEMENT_REQUEST = {
  cduId: '018481',
  license: {
    type: 'Open',
    validFrom: '2024-08-20',
    validTo: '2025-08-15',
  },
  orgId: 'OrcgmLZg',
  serviceEndDate: '2025-08-15',
  serviceStartDate: '2024-08-20',
  serviceType: 'Trial',
  status: 'Active',
};

export const ORG_DATA_PRODUCT_ENTITLEMENT_RESPONSE = {
  cduId: 'Cx018481',
  config: null,
  createdAt: '2024-08-19T16:08:59.279+0000',
  dataProductId: 'PrD9b5h3S5mr',
  id: 'Suffe4cd7b483005',
  itemPriceId: null,
  license: {
    type: 'Open',
    validFrom: '2024-08-20T00:00:00.000+0000',
    validTo: '2025-08-15T00:00:00.000+0000',
  },
  modifiedAt: '2024-08-19T16:08:59.279+0000',
  orgId: 'OrcgmLZg',
  serviceEndDate: '2025-08-15T00:00:00.000+0000',
  serviceStartDate: '2024-08-20T00:00:00.000+0000',
  serviceType: 'Trial',
  status: 'Active',
  type: 'gcs',
};

export const ORG_DATA_PRODUCT_SUBSCRIPTIONS = [
  {
    cduId: 'Cx55052',
    config: null,
    createdAt: '2025-03-27T20:56:22.307+0000',
    id: 'Su85b0fd395afcb9',
    itemPriceId: null,
    license: null,
    modifiedAt: '2025-03-27T20:56:22.307+0000',
    orgId: 'Or8HW9qI',
    serviceEndDate: '2025-07-26T00:00:00.000+0000',
    serviceStartDate: '2025-03-27T00:00:00.000+0000',
    serviceType: 'Trial',
    status: 'Active',
    type: 'gcs',
  },
  {
    cduId: 'Cx55053',
    config: null,
    createdAt: '2025-03-27T20:56:22.307+0000',
    id: 'Su85b0fd39',
    itemPriceId: null,
    license: null,
    modifiedAt: '2025-03-27T20:56:22.307+0000',
    orgId: 'Or8HW9qI',
    serviceEndDate: '2025-07-26T00:00:00.000+0000',
    serviceStartDate: '2025-03-27T00:00:00.000+0000',
    serviceType: 'Trial',
    status: 'Active',
    type: 'gcs',
  },
  {
    cduId: 'Cx55054',
    config: null,
    createdAt: '2025-03-27T20:56:22.307+0000',
    id: 'Su85b0fd395af',
    itemPriceId: null,
    license: null,
    modifiedAt: '2025-03-27T20:56:22.307+0000',
    orgId: 'Or8HW9qI',
    serviceEndDate: '2025-07-26T00:00:00.000+0000',
    serviceStartDate: '2025-03-27T00:00:00.000+0000',
    serviceType: 'Trial',
    status: 'Active',
    type: 'gcs',
  },
];
